//引入vue和vue-router
import Vue from 'vue';
import VueRouter from 'vue-router';
//引入路由页面
import mainView from '../src/pages/main';
import HomeView from '../src/pages/home';
import aboutView from '../src/pages/about';
import aboutProduct from '../src/pages/aboutProduct';
import aboutDesign from '../src/pages/aboutDesign';
import service from '../src/pages/service';
import serviceOrder from '../src/pages/service/serviceOrder';
import serviceQuality from '../src/pages/service/serviceQuality';
import product from '../src/pages/product';
import cooperate from '../src/pages/cooperate';
import contactUs from '../src/pages/contactUs';
import contactMessage from '../src/pages/contactMessage';
import disclaimer from '../src/pages/statement/disclaimer';
import privacy from '../src/pages/statement/privacy';
Vue.use(VueRouter);

//定义路由
const routes = [
  {
    path: '/',
    name: 'mian',
    component: mainView,
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/about',
    name: 'about',
    component: aboutView,
  },
  {
    path: '/aboutProduct',
    name: 'aboutProduct',
    component: aboutProduct,
  },
  {
    path: '/aboutDesign',
    name: 'aboutDesign',
    component: aboutDesign,
  },
  {
    path: '/service',
    name: 'service',
    component: service,
  },
  {
    path: '/serviceOrder',
    name: 'serviceOrder',
    component: serviceOrder,
  },
  {
    path: '/serviceQuality',
    name: 'serviceQuality',
    component: serviceQuality,
  },
  {
    path: '/product',
    name: 'product',
    component: product,
  },
  {
    path: '/cooperate',
    name: 'cooperate',
    component: cooperate,
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: contactUs,
  },
  {
    path: '/contactMessage',
    name: 'contactMessage',
    component: contactMessage,
  },
  {
    path: '/disclaimer',
    name: 'disclaimer',
    component: disclaimer,
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: privacy,
  },
];

//创建路由
const router = new VueRouter({
  //模式
  mode: 'history',
  //使用定义的路由
  routes,
});

export default router;
